import { render, staticRenderFns } from "./SelectShop.vue?vue&type=template&id=06cc33a1&scoped=true"
import script from "./SelectShop.vue?vue&type=script&lang=js"
export * from "./SelectShop.vue?vue&type=script&lang=js"
import style0 from "./SelectShop.vue?vue&type=style&index=0&id=06cc33a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc33a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cc33a1')) {
      api.createRecord('06cc33a1', component.options)
    } else {
      api.reload('06cc33a1', component.options)
    }
    module.hot.accept("./SelectShop.vue?vue&type=template&id=06cc33a1&scoped=true", function () {
      api.rerender('06cc33a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/SelectShop.vue"
export default component.exports